import React,{useState,useEffect, useRef} from 'react'
import { Navbar, Nav, Container, Row, Button,FormControl,Form,Col,Toast, Card, Jumbotron} from "react-bootstrap";
import axios from "axios"
import classes from "./App.module.css"
function NewsPage() {
    const [reload,setReload] = useState(true)
    const [news,setNews] = useState([]);
    useEffect(()=>{
        if (reload) {
            axios.get("https://newsapi.org/v2/top-headlines?country=in&category=business&apiKey=095266d3bc084938b1cd18a4dc54fea8")
                .then(res =>{
                    console.log(res)
                    setNews(res.data.articles)
                })
                .catch(error=>{
                    console.log(error);
                })
                setReload(false)
        }
    })
    return (
        <div>
            <Container>
            <div align="center">
              <h2>Trending Topics</h2>
              <hr style={{width:"150px",height:"2px",color:"white",backgroundColor:"black",borderRadius:"15%"}} />
            </div>
            <br/>
                <Row >
                        {news.length>0 && news.map((item,index)=>{
                        return(
                            <Col md={4}>
                            <Card onClick={()=>{window.open(item.url)}}  key={index} style={{marginBottom:"20px"}}>
                            <Card.Img src={item.urlToImage} style={{height:"200px"}}/>
                            <Card.Header className={classes.Text} style={{height:"65px"}}>
                            <strong className="mr-auto">{item.title} {index+1}</strong>
                            </Card.Header>
                        </Card>
                        </Col>
                        )
                        })}
                        
                 </Row>
            </Container>
        </div>
    )
}

export default NewsPage
